import { type FC, useEffect } from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useAiRovoCurrentRouteConfigurationStoreActions } from '@jira/ai-rovo_actions-store/src/aiRovoCurrentRouteConfigurationStore.tsx';
import { useAvailabilityRovoConfig } from '@jira/servicedesk__availability/src/AvailabilityRovoConfigProviderEntry.tsx';

export const AiRovoAvailabilityNudgesProvider: FC<{}> = (): null => {
	const { updateConfiguration } = useAiRovoCurrentRouteConfigurationStoreActions();
	const availabilityConfig = useAvailabilityRovoConfig();

	useEffect(() => {
		if (!expVal('jsm-workforce-skill-experiment', 'isEnabled', false)) {
			return;
		}

		updateConfiguration({
			// nudges to be added in a follow-up
			nudges: [],
			getActions: availabilityConfig.getActions,
			tags: availabilityConfig.tags,
		});
	}, [availabilityConfig, updateConfiguration]);

	return null;
};
